// Per-page help content shared between HelpDrawer and DarumaFab.
// The caller passes its own translator (typeof useTranslation('pages').t)
// so keys resolve in the active language and re-render on language change.

export interface PageHelpEntry {
  title: string;
  tips: { label: string; text: string }[];
}

type Translator = (key: string) => string;

export function getPageHelp(path: string, t: Translator): PageHelpEntry | null {
  const basePath = path.split('?')[0];
  const parentPath = '/' + (basePath.split('/')[1] || '');

  const map: Record<string, PageHelpEntry> = {
    '/': {
      title: t('helpDrawer.dashboard.title'),
      tips: [
        { label: t('helpDrawer.dashboard.stats.label'), text: t('helpDrawer.dashboard.stats.text') },
        { label: t('helpDrawer.dashboard.weeklySpot.label'), text: t('helpDrawer.dashboard.weeklySpot.text') },
        { label: t('helpDrawer.dashboard.progress.label'), text: t('helpDrawer.dashboard.progress.text') },
      ],
    },
    '/dream': {
      title: t('helpDrawer.dream.title'),
      tips: [
        { label: t('helpDrawer.dream.explore.label'), text: t('helpDrawer.dream.explore.text') },
        { label: t('helpDrawer.dream.library.label'), text: t('helpDrawer.dream.library.text') },
        { label: t('helpDrawer.dream.passport.label'), text: t('helpDrawer.dream.passport.text') },
      ],
    },
    '/trip-planner': {
      title: t('helpDrawer.tripPlanner.title'),
      tips: [
        { label: t('helpDrawer.tripPlanner.dates.label'), text: t('helpDrawer.tripPlanner.dates.text') },
        { label: t('helpDrawer.tripPlanner.views.label'), text: t('helpDrawer.tripPlanner.views.text') },
        { label: t('helpDrawer.tripPlanner.transit.label'), text: t('helpDrawer.tripPlanner.transit.text') },
        { label: t('helpDrawer.tripPlanner.sidebar.label'), text: t('helpDrawer.tripPlanner.sidebar.text') },
        { label: t('helpDrawer.tripPlanner.phrasebook.label'), text: t('helpDrawer.tripPlanner.phrasebook.text') },
        { label: t('helpDrawer.tripPlanner.restaurantTags.label'), text: t('helpDrawer.tripPlanner.restaurantTags.text') },
        { label: t('helpDrawer.tripPlanner.aiRegen.label'), text: t('helpDrawer.tripPlanner.aiRegen.text') },
      ],
    },
    '/travel': {
      title: t('helpDrawer.travel.title'),
      tips: [
        { label: t('helpDrawer.travel.myTrips.label'), text: t('helpDrawer.travel.myTrips.text') },
        { label: t('helpDrawer.travel.planner.label'), text: t('helpDrawer.travel.planner.text') },
        { label: t('helpDrawer.travel.canvas.label'), text: t('helpDrawer.travel.canvas.text') },
        { label: t('helpDrawer.travel.offline.label'), text: t('helpDrawer.travel.offline.text') },
      ],
    },
    '/share': {
      title: t('helpDrawer.share.title'),
      tips: [
        { label: t('helpDrawer.share.community.label'), text: t('helpDrawer.share.community.text') },
        { label: t('helpDrawer.share.voting.label'), text: t('helpDrawer.share.voting.text') },
        { label: t('helpDrawer.share.leaderboard.label'), text: t('helpDrawer.share.leaderboard.text') },
      ],
    },
    '/achievements': {
      title: t('helpDrawer.achievements.title'),
      tips: [
        { label: t('helpDrawer.achievements.badges.label'), text: t('helpDrawer.achievements.badges.text') },
        { label: t('helpDrawer.achievements.xp.label'), text: t('helpDrawer.achievements.xp.text') },
        { label: t('helpDrawer.achievements.ranks.label'), text: t('helpDrawer.achievements.ranks.text') },
      ],
    },
    '/credits': {
      title: t('helpDrawer.credits.title'),
      tips: [
        { label: t('helpDrawer.credits.earning.label'), text: t('helpDrawer.credits.earning.text') },
        { label: t('helpDrawer.credits.shop.label'), text: t('helpDrawer.credits.shop.text') },
        { label: t('helpDrawer.credits.modes.label'), text: t('helpDrawer.credits.modes.text') },
      ],
    },
    '/profile': {
      title: t('helpDrawer.profile.title'),
      tips: [
        { label: t('helpDrawer.profile.travelMode.label'), text: t('helpDrawer.profile.travelMode.text') },
        { label: t('helpDrawer.profile.security.label'), text: t('helpDrawer.profile.security.text') },
        { label: t('helpDrawer.profile.data.label'), text: t('helpDrawer.profile.data.text') },
      ],
    },
    '/agent': {
      title: t('helpDrawer.agent.title'),
      tips: [
        { label: t('helpDrawer.agent.clients.label'), text: t('helpDrawer.agent.clients.text') },
        { label: t('helpDrawer.agent.bulkImport.label'), text: t('helpDrawer.agent.bulkImport.text') },
        { label: t('helpDrawer.agent.assignTrip.label'), text: t('helpDrawer.agent.assignTrip.text') },
        { label: t('helpDrawer.agent.branding.label'), text: t('helpDrawer.agent.branding.text') },
        { label: t('helpDrawer.agent.marketplace.label'), text: t('helpDrawer.agent.marketplace.text') },
        { label: t('helpDrawer.agent.export.label'), text: t('helpDrawer.agent.export.text') },
        { label: t('helpDrawer.agent.aiQuota.label'), text: t('helpDrawer.agent.aiQuota.text') },
      ],
    },
  };

  return map[basePath] || map[parentPath] || null;
}
